export const matchToCadastralMask = (value: string): boolean => /^[\d]+(:[\d]+){3}$/.test(value);
